export default __webpack_public_path__ + "static/media/pin-stripes.fca7490e57e209772e1d2b641f97e4b2.svg";